// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer {\n  background-color: #f6f4f0;\n}\n.footer .footer_info {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 72px 0px;\n}\n.footer .footer_info .logo_info {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n.footer .footer_info .logo_info img.logo {\n  width: 180px;\n  margin-bottom: 32px;\n}\n.footer .footer_info .logo_info p {\n  color: #1e1e1e;\n  font-size: 13px;\n}\n.footer .footer_info .logo_info .share {\n  margin-top: 32px;\n}\n.footer .footer_info .logo_info .share [class^=yy-icon-] {\n  font-size: 32px;\n  margin-right: 18px;\n}\n.footer .footer_info .logo_info .share a {\n  color: #1e1e1e;\n}\n.footer .footer_info .logo_info .share .qrcode {\n  height: 125px;\n  width: 125px;\n  position: absolute;\n  right: -123px;\n  display: none;\n  bottom: 0;\n  border: 2px solid #ae9a69;\n}\n.footer .footer_info .logo_info .iWeChat:hover .qrcode {\n  display: block;\n}\n.footer .footer_info .info {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n.footer .footer_info .info h3 {\n  font-size: 18px;\n  letter-spacing: 2px;\n  margin-bottom: 16px;\n}\n.footer .footer_info .info dl {\n  color: #1e1e1e;\n  font-size: 13px;\n  line-height: 2;\n  letter-spacing: 3px;\n}\n.footer .footer_bottom {\n  padding: 24px 0;\n  font-size: 13px;\n  color: #1e1e1e;\n  text-align: center;\n}\n.footer .footer_bottom a {\n  color: #1e1e1e;\n}\n.footer .yy-icon-ArrowTop {\n  font-size: 32px;\n}", ""]);
// Exports
exports.locals = {
	"color_default": "#ae9a69",
	"color_default_block": "#b4a172",
	"color_default_light": "#f6f4f0",
	"color_dark": "#1e1e1e",
	"color_dark2": "#000000",
	"color_grey4": "#fbfbfd",
	"color_grey3": "#999999",
	"color_grey2": "#e1e1e1",
	"color_grey1": "#f4f4f4",
	"color_lightBg": "#F7F8FB",
	"color_white": "#FFFFFF",
	"color_uired": "#b41d23",
	"color_uigreen": "#2bb578",
	"color_fb": "#3c599b",
	"color_qq": "#68a5e1",
	"color_vx": "#4ba44c",
	"color_wb": "#ff9933"
};
module.exports = exports;
